// extracted by mini-css-extract-plugin
export default {"inpBlockCl":"InputBlock_inpBlockCl__E51DC","textCl":"InputBlock_textCl__HYTGk"};